<template>
  <div class="guidelines" :class="sections.five ? 'guidelines-last-slide ' : ''">
    <div class="guidelines-section" v-if="sections.one">
      <p class="guidelines-intro">
        By using Cofocus and doing sessions on Cofocus, you agree to follow the rules set forth in our
        <a href="/help/community-guidelines" target="_blank">Community Guidelines</a>
        and in the Session Guidelines here.
      </p>
      <!-- <p>
        Read our session guidelines below to help you and your session partner
        get the most out of a Cofocus session and to make sure you&apos;re
        behaving according to the rules of Cofocus.
      </p> -->
      <p class="guidelines-title">Session format</p>
      <ol>
        <li>Greet your partner and ask them how they&apos;re doing</li>
        <li>
          Spend 10-30 seconds describing what you&apos;ll be working on during the session
        </li>
        <li>
          Wish your partner good luck and get to work on the tasks you&apos;ve declared
        </li>
        <li>
          Once the session is over, exchange how your session went with your partner
        </li>
      </ol>
      <p class="guidelines-note">
        You can also watch our introductory video
        <a href="https://www.youtube.com/watch?v=Gay2--UbvVI" target="_blank">How to Use Cofocus for First Timers</a>!
      </p>
      <!-- <p class="guidelines-note">
        You can check our
        <a href="https://www.google.com" target="_blank">Guides</a> to learn
        more about how Cofocus works and you can also watch our introductory
        <a href="https://www.youtube.com/watch?v=Gay2--UbvVI" target="_blank"
          >How-To video</a
        >.
      </p> -->
    </div>
    <div class="guidelines-section" v-if="sections.two">
      <p class="guidelines-title">We request that you:</p>
      <ul>
        <div class="guidelines-card">
          <div class="guidelines-check">✔️</div>
          <div class="guidelines-card-text">
            Show up to your sessions and join them on time. There will be a real person waiting for you on the other side.
          </div>
        </div>
        <div class="guidelines-card">
          <div class="guidelines-check">✔️</div>
          <div class="guidelines-card-text">Keep your camera on throughout the session. <strong>Remember that camera is mandatory on Cofocus</strong>.</div>
        </div>
        <div class="guidelines-card">
          <div class="guidelines-check">✔️</div>
          <div class="guidelines-card-text">
            Set up your camera so that it has a clear, unobstructed view of your face.
          </div>
        </div>
        <div class="guidelines-card">
          <div class="guidelines-check">✔️</div>
          <div class="guidelines-card-text">
            Inform your partner through the chat or use the BRB button if you need to take a water or bathroom break.
          </div>
        </div>
        <div class="guidelines-card">
          <div class="guidelines-check">✔️</div>
          <div class="guidelines-card-text">
            Keep the chit-chat to a minimum at the start of the session.
          </div>
        </div>
        <div class="guidelines-card">
          <div class="guidelines-check">✔️</div>
          <div class="guidelines-card-text">
            If you need to cancel a session,
            <strong>do it ahead of time</strong>, so your partner would have a better chance to get matched with someone else.
          </div>
        </div>
        <!-- <li class="guidelines-card">Be friendly.</li> -->
        <!-- <li>
          Do your best to show up with your camera and microphone working. (Need
          help? Contact us or read our How To Guides.)
        </li> -->
      </ul>
    </div>
    <div class="guidelines-section" v-if="sections.three">
      <p class="guidelines-title">Forbidden</p>
      <ul>
        <div class="guidelines-card">
          <div class="guidelines-check">❌</div>
          <div class="guidelines-card-text">
            Do not turn off your camera unless an emergency. Screenshare and/or mic only formats are not allowed.
          </div>
        </div>
        <div class="guidelines-card">
          <div class="guidelines-check">❌</div>
          <div class="guidelines-card-text">
            Do not leave the session early or without letting your partner know.
          </div>
        </div>
        <div class="guidelines-card">
          <div class="guidelines-check">❌</div>
          <div class="guidelines-card-text">
            Do not go somewhere else and disappear without letting your partner know why and for how long.
          </div>
        </div>
        <div class="guidelines-card">
          <div class="guidelines-check">❌</div>
          <div class="guidelines-card-text">
            Do not start a conversation during the session.
          </div>
        </div>
        <div class="guidelines-card">
          <div class="guidelines-check">❌</div>
          <div class="guidelines-card-text">
            Do not take screenshots, pictures or recordings of the session.
          </div>
        </div>
        <div class="guidelines-card">
          <div class="guidelines-check">❌</div>
          <div class="guidelines-card-text">
            Avoid socializing with others around you (this can be distracting to your partner).
          </div>
        </div>
      </ul>
    </div>
    <div class="guidelines-section" v-if="sections.four">
      <p class="guidelines-title">Tips & Recommendations</p>
      <ul>
        <div class="guidelines-card">
          <div class="guidelines-check">🔅</div>
          <div class="guidelines-card-text">
            Come into the session prepared, knowing what you&apos;ll be working on.
          </div>
        </div>
        <div class="guidelines-card">
          <div class="guidelines-check">🔅</div>
          <div class="guidelines-card-text">
            Keep your tasks specific and achievable.
          </div>
        </div>
        <div class="guidelines-card">
          <div class="guidelines-check">🔅</div>
          <div class="guidelines-card-text">
            Protect your attention and remove distractions ahead of time (e.g. put away your phone). When you get distracted, it can distract your partner as well.
          </div>
        </div>
        <div class="guidelines-card">
          <div class="guidelines-check">🔅</div>
          <div class="guidelines-card-text">
            Check in with your partner before engaging them in conversation to make sure they really have the time &mdash; not everyone feels comfortable telling you they need to be working.
          </div>
        </div>
        <div class="guidelines-card">
          <div class="guidelines-check">🔅</div>
          <div class="guidelines-card-text">
            Work hard and with intent. When you&apos;re focused and working hard, it can inspire your partner to work even harder, which will in return inspire you.
          </div>
        </div>
      </ul>
    </div>
    <div class="guidelines-section" v-if="sections.five">
      <p class="guidelines-title">That's it!</p>
      <ul>
        <div class="guidelines-card">
          <div class="guidelines-check">ℹ️</div>
          <div class="guidelines-card-text">
            If you experience any technical troubles, read our Troubleshoot Guide or reach out to us at support@cofocus.one.
          </div>
        </div>
        <div class="guidelines-card">
          <div class="guidelines-check">❗</div>
          <div class="guidelines-card-text">
            If you come across any bad behavior or someone breaking our guidelines, please report them to us.
          </div>
        </div>
        <div class="guidelines-card">
          <div class="guidelines-check">❓</div>
          <div class="guidelines-card-text">
            For anything else, feel free to reach out at hello@cofocus.one.
          </div>
        </div>
      </ul>
      <p class="guidelines-title">Happy sessioning! 🦄</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "SessionGuidelines",
  props: {
    sections: Object,
  },
};
</script>

<style scoped>
.guidelines {
  height: calc(490px / var(--heightResoRatio));
  overflow: hidden;
}

.guidelines-last-slide {
  height: calc(345px / var(--heightResoRatio));
}

.guidelines-intro {
  font-size: calc(15px / var(--widthResoRatio));
  text-align: center;
}

.guidelines-title {
  text-align: center;
  font-size: calc(24px / var(--widthResoRatio));
  font-weight: 600;
  justify-content: center;
  display: flex;
}
.guidelines-title p {
  margin-top: calc(26px / var(--heightResoRatio)) !important;
}
.guidelines-intro p {
  margin-bottom: calc(10px / var(--heightResoRatio)) !important;
}

.guidelines-note {
  text-align: center;
  font-size: calc(14px / var(--widthResoRatio));
  margin-top: 0px !important;
  line-height: calc(20px / var(--heightResoRatio));
  background-color: #f5f5f5;
  border-radius: 12px;
  padding: calc(10px / var(--heightResoRatio)) calc(14px / var(--widthResoRatio));
  font-weight: 600;
}

.guidelines-card {
  padding: calc(3px / var(--widthResoRatio)) 0px !important;
  box-sizing: border-box;
  font-size: calc(16px / var(--widthResoRatio));
  margin: calc(8px / var(--widthResoRatio)) 0px;
  border-radius: 12px;
  width: calc(90% / var(--widthResoRatio));
  margin-left: calc(20px / var(--widthResoRatio)) !important;
  margin-right: auto;
  display: flex;
  line-height: calc(22px / var(--heightResoRatio));
}

.guidelines-check {
  margin-right: calc(10px / var(--widthResoRatio));
}

.guidelines p,
.guidelines h1,
.guidelines h2,
.guidelines h3,
.guidelines h4,
.guidelines h5 {
  margin-top: calc(20px / var(--heightResoRatio)) !important;
}

.guidelines p {
  line-height: calc(22px / var(--heightResoRatio));
}

.guidelines p,
.guidelines h1,
.guidelines h2,
.guidelines h3,
.guidelines h4,
.guidelines h5,
.guidelines pre {
  font-family: "Nunito" !important;
}

.guidelines h3 {
  font-size: calc(23px / var(--widthResoRatio));
  margin-top: calc(30px / var(--heightResoRatio)) !important;
}

.guidelines ul {
  margin: calc(25px / var(--heightResoRatio)) 0px;
}

.guidelines ol {
  margin: calc(10px / var(--heightResoRatio)) 0px;
}

.guidelines ul li {
  list-style: disc;
}

.guidelines ol li {
  list-style: decimal;
  font-size: calc(16px / var(--widthResoRatio)) !important;
}

.guidelines li {
  margin-left: calc(40px / var(--widthResoRatio));
  padding: calc(8px / var(--heightResoRatio)) 0px;
  line-height: calc(22px / var(--heightResoRatio));
}

.guidelines a {
  color: #304976;
  text-decoration: underline;
}
.guidelines a {
  outline: 0;
  transition: color 0.2s linear;
}
.guidelines a:focus,
.guidelines a:hover {
  text-decoration: none;
}
</style>
